export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9733.8c6dc3ad.jpg";